export default __webpack_public_path__ + "static/media/claim_failed.56ea0bce.png";